<template>
  <div class="achievements">
    <div class="body-content" style="background-color: #fff;">
      <div class="outcome-header">
        <div class="title">亮点成果</div>
        <div class="sub-title">Highlight achievements</div>
        <div class="line"></div>
      </div>
      <div class="card">
        <div class="left">
          <a href="/bright?tab=计量">
            <img src="../../assets/images/hot-back/jl.png" alt="">
          </a>
          <div>计量</div>
          <div>Metering</div>
        </div>
        <div class="right">
          <div class="r-left">
            <div class="top">
              <a href="/bright?tab=标准">
                <img src="../../assets/images/hot-back/bz.png" alt="">
              </a>
              <div>标准</div>
              <div>tandard</div>
            </div>
            <div class="top" style="margin-top: 40px;">
              <a href="/bright?tab=检验检测">
                <img src="../../assets/images/hot-back/jyjc.png" alt="">
              </a>
              <div>检验检测</div>
              <div>Examine</div>
            </div>
          </div>
          <div class="r-right">
            <div class="top">
              <a href="/bright?tab=认证认可">
                <img src="../../assets/images/hot-back/rzrk.png" alt="">
              </a>
              <div>认证认可</div>
              <div>Certification</div>
            </div>
            <div class="top" style="margin-top: 40px;">
              <a href="/bright?tab=典型示范">
                <img src="../../assets/images/hot-back/dxsf.png" alt="">
              </a>
              <div>典型示范</div>
              <div>Typical demonstratio</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 成果形式 -->
      <div class="outcome">
        <div class="outcome-header">
          <div class="title">VR展厅</div>
          <div class="sub-title">Virtual reality exhibition hall</div>
          <div class="line" style="margin-bottom: 16px"></div>
          <div class="VR">
            <ul>
              <li v-for="fruit in fruitList" :key="fruit.id">
                <div class="image-box" @click="goDetail(fruit.id)">
                  <img :src="fileUrl + fruit.coverImage" alt="">
                  <span class="label-text">{{fruit.nowStage}}</span>
                </div>
                <div class="content">
                  <p class="name-box">
                    <span class="name" @click="goDetail(fruit.id)">{{fruit.fruitName}}</span>
                    <img v-if="fruit.vrUrl" src="../../assets/images/360@2x.png" alt="VR">
                    <img v-if="fruit.mp4Url" src="../../assets/images/video@2x.png" alt="视频">
                  </p>
                  <p class="text"><span>项目名称：</span>{{fruit.projectName}}</p>
                  <p class="text"><span>课题名称：</span>{{fruit.taskName}}</p>
                </div>
              </li>
            </ul>
            <div class="more pointer" @click="toPath('/VRShow')">更多</div>
          </div>
        </div>
        <div class="outcome-header">
          <div class="title">成果形式</div>
          <div class="sub-title">Achievement form</div>
          <div class="line"></div>
        </div>
        <div class="outcome-body">
          <div class="swiper-item">
            <ul>
              <li
                class="pointer"
                v-for="(item, index) in outcomeData"
                :key="index"
                @click="toPath('/canonical', {type: item.text})"
              >
                <img :src="item.img" alt="">
                <div class="mask">{{item.text}}</div>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>

    <div style="background-color: rgba(246, 247, 251, 1);margin-top: 24px">
      <div class="body-content">
        <div class="banner-image" id="typeChart" style="height: 600px;"></div>
        <!-- 人才培养与论文展览馆 -->
        <!--<div class="humanities-culture">
          <div class="humanities-culture-header">
            <span>人才培养与论文展览馆</span>
          </div>
          <div class="humanities-culture-body">
            <div class="left">
              <img src="../../assets/images/achievements/位图@2x(2).png" alt="">
              <div class="mask">玻尔兹曼测定相关论文</div>
            </div>
            <div class="right">
              <div class="desc">
                <p>项目完全实现了任务书预期研究目标，建立了一套完整的混合式角度测量系统，与国家激光小角度基准、面角度基准、线角度基准一一对应，将激光反正弦测角、多面棱体测角、圆光栅测角原理一体化集成。其他国家计量院均只基于单一测量原理研制角度计量标准装置，具备如下显著的优点：（1）实现了全测量空间内不同测量原理的实时混合，实时相验，对外界参考标准器的依赖性低，充分满足目前全球疫情常态化下，国家角度基准长期可靠性保证需求；（2）实现了不同测量原理的优势互补、交替测量，具备的全圆范围、超高分辨力、动态测量综合技术优势，突破了原有角度计量体系分段离散测量、静态测量的技术局限，支撑角度计量体系的全面升级。</p>
              </div>
              <div class="bottom">
                <div class="item">
                  <img src="../../assets/images/achievements/矩形@2x(7).png" alt="">
                  <div class="mask">普朗克常数测定相关论文</div>
                </div>
                <div class="item">
                  <img src="../../assets/images/achievements/矩形@2x(8).png" alt="">
                  <div class="mask">轴类超声检测的波束扩散成像</div>
                </div>
              </div>
            </div>
          </div>
          <div class="avatar-list">
            <div class="avatar-item"
              v-for="(item, index) in avatarList"
              :key="index"
            >
              <img :src="item.img" alt="">
              <div class="mask">{{item.text}}</div>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fileUrl: '',
      fruitList: [],
      outcomeData: [
        {
          img: require('../../assets/images/achievements/矩形@2x(4).png'),
          text: '计量基标准'
        },
        {
          img: require('../../assets/images/achievements/蒙版@2x(1).png'),
          text: '规程/规范'
        },
        {
          img: require('../../assets/images/achievements/矩形@2x.png'),
          text: '国际/国内比对'
        },
        {
          img: require('../../assets/images/achievements/矩形@2x(1).png'),
          text: '国际互认的测量和校准能力'
        },
        {
          img: require('../../assets/images/achievements/矩形@2x(2).png'),
          text: '国家标准物质'
        },
        {
          img: require('../../assets/images/achievements/蒙版@2x.png'),
          text: '标准样品'
        },
        {
          img: require('../../assets/images/achievements/蒙版@2x(2).png'),
          text: '国际标准'
        },
        {
          img: require('../../assets/images/achievements/矩形@2x(3).png'),
          text: '国内标准'
        },
        {
          img: require('../../assets/images/achievements/矩形@2x(5).png'),
          text: '国内标准修改单'
        },
        {
          img: require('../../assets/images/achievements/矩形@2x(6).png'),
          text: '检测设备/仪器'
        }
      ],
      avatarList: [
        {
          img: require('../../assets/images/achievements/矩形@2x(11).png'),
          text: '近海简易风电基础结构设计研究'
        },
        {
          img: require('../../assets/images/achievements/矩形@2x(12).png'),
          text: '培养研究生5人'
        },
        {
          img: require('../../assets/images/achievements/矩形@2x(9).png'),
          text: '硕士研究生人才培养'
        },
        {
          img: require('../../assets/images/achievements/矩形@2x(10).png'),
          text: '经济性结构风险预警技术研究'
        },
        {
          img: require('../../assets/images/achievements/矩形@2x(15).png'),
          text: '冰区风电基础结构抗冰振设计研究'
        },
        {
          img: require('../../assets/images/achievements/矩形@2x(16).png'),
          text: '大型海上风机浮托安装监控技术研究'
        },
        {
          img: require('../../assets/images/achievements/矩形@2x(13).png'),
          text: '培养博士研究生'
        },
        {
          img: require('../../assets/images/achievements/矩形@2x(14).png'),
          text: '培养学生'
        }
      ],
      typeList: []
    }
  },
  created () {
    this.fileUrl = FileUrl;
    this.fetchFruitList();
    this.drawChart()
  },
  methods: {
    toPath (path, query) {
      this.$router.push({path, query})
    },
    fetchFruitList () {
      const _self = this;
      _self.fetch('/dataapi/open/nqi/fruit/listVrShow', {pageNo: 1, pageSize: 6}).then(res => {
        _self.fruitList = res.result.records;
      });
    },
    goDetail (id) {
      this.$router.push({path: '/fruitDetail', query: {id: id}});
    },
    drawChart () {
      const _self = this;
      this.fetch('/dataapi/open/nqi/fruit/getFruitCountByStyle').then(res => {
        _self.typeList = res.result;
        _self.chart = echarts.init(document.getElementById('typeChart'));
        let yAxis = [];
        let value = [];
        for (let item of _self.typeList) {
          yAxis.push(item.fruit_style);
          value.push({
            itemStyle: {
              color: '#136bae'
            },
            value: item.rs
          });
        }
        _self.chart.setOption({
          title: {
            left: 'center',
            text: '成果形式分布',
            subtext: 'Distribution form of achievements',
            padding: 30
          },
          xAxis: {
            type: 'category',
            splitLine: {show: false},
            axisLabel: {'interval': 0, rotate: 30},
            data: yAxis
          },
          yAxis: {
            type: 'log',
            minorSplitLine: {
              show: true
            }
          },
          grid: {
            top: 120,
            bottom: 80,
            left: 40,
            right: 40
          },
          series: [
            {
              name: '成果形式分布',
              type: 'bar',
              label: {
                show: true
              },
              data: value
            }
          ]
        });
      });
    }
  }
}
</script>

<style lang="less" scoped>
.body-content {
  width: @body-width;
  margin: 0 auto;
}
.achievements {
  padding-top: 41px;
  .banner-image {
    padding-bottom: 120px;
    width: 100%;
    img {
      width: 100%;
    }
  }

  .VR {
    padding-bottom: 60px;
    ul {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 40px;
      li {
        flex: 0 0 410px;
        margin-right: 25px;
        margin-bottom: 20px;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .image-box {
          position: relative;
          width: 410px;
          height: 280px;
          img {
            width: 100%;
            height: 100%;
            border: 1px solid rgba(0, 0, 0, 0.1);
          }
          .label-text {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
            width: 72px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 14px;
            color: #fff;
            background-color: rgba(170, 47, 51, 1);
          }
        }
        .content {
          padding: 24px;
          border: 1px solid rgba(0, 0, 0, 0.1);
          border-top: 0;
          box-sizing: border-box;
          .name-box {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .name {
              cursor: pointer;
              margin-right: 10px;
              font-size: 16px;
              line-height: 22px;
              color: rgba(46, 92, 154, 1);
            }
            img {
              display: block;
              width: 32px;
              height: 32px;
              margin-right: 4px;
            }
          }
          .text {
            margin-bottom: 7px;
            font-size: 14px;
            line-height: 20px;
            color: rgba(0, 0, 0, 0.65);
            display: flex;
            span:first-child {
              width: 86px;
            }
          }
          .tip {
            display: flex;
            align-items: center;
            .text {
              margin-right: 12px;
              margin-bottom: 0;
              font-size: 14px;
              line-height: 20px;
              color: rgba(0, 0, 0, 0.65);
            }
            .status {
              width: 48px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              font-size: 14px;
              color: #fff;
              border-radius: 2px;
              &.show {
                background-color: rgba(170, 47, 51, 1);
              }
              &.end {
                background-color: rgba(0, 0, 0, 0.65);
              }
            }
          }
        }
      }
    }
    .more {
      margin: 0 auto;
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.65);
      border: 1px solid rgba(0, 0, 0, 0.1);
    }
  }

  .outcome-header {
    padding-top: 30px;
    padding-bottom: 20px;

    .title {
      height: 42px;
      font-size: 30px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 42px;
      margin: 0 auto;
      text-align: center;
    }

    .sub-title {
      text-align: center;
      margin: 0 auto;
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #D0D0D0;
      line-height: 25px;
      margin-top: 4px;
    }

    .line {
      margin: 0 auto;
      width: 61px;
      height: 3px;
      background: #E12422;
      margin-top: 8px;
    }
  }
  .card {
    display: flex;
    justify-content: space-between;
    height: 268px;
    .left {
      width: 30%;
      height: 100%;
      position: relative;
      img {
        width: 100%;
        height: 268px;
      }
      div:nth-of-type(1){
        position: absolute;
        top: 24px;
        left: 24px;
        height: 33px;
        font-size: 24px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 33px;
      }
      div:nth-of-type(2){
        position: absolute;
        top: 61px;
        left: 24px;
        height: 24px;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 24px;
      }
    }
    .right {
      width: 68%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      .r-left,.r-right {
        width: 48.5%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .top {
          position: relative;
          img {
            width: 100%;
            height: 114px;
          }
          div:nth-of-type(1){
            position: absolute;
            top: 24px;
            left: 24px;
            height: 33px;
            font-size: 24px;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 33px;
          }
          div:nth-of-type(2){
            position: absolute;
            top: 61px;
            left: 24px;
            height: 24px;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 24px;
          }
        }
      }
      .r-right {
        width: 48.5%;
      }
    }
  }

  .outcome {
    padding-bottom: 48px;
    .outcome-header {
      padding-top: 30px;
      padding-bottom: 20px;

      .title {
        height: 42px;
        font-size: 30px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 42px;
        margin: 0 auto;
        text-align: center;
      }

      .sub-title {
        text-align: center;
        margin: 0 auto;
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #D0D0D0;
        line-height: 25px;
        margin-top: 4px;
      }

      .line {
        margin: 0 auto;
        width: 61px;
        height: 3px;
        background: #E12422;
        margin-top: 8px;
      }
    }
    .card {
      display: flex;
      justify-content: space-between;
      height: 268px;
      .left {
        width: 30%;
        height: 100%;
        position: relative;
        img {
          width: 100%;
          height: 268px;
        }
        div:nth-of-type(1){
          position: absolute;
          top: 24px;
          left: 24px;
          height: 33px;
          font-size: 24px;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 33px;
        }
        div:nth-of-type(2){
          position: absolute;
          top: 61px;
          left: 24px;
          height: 24px;
          font-size: 20px;
          color: #FFFFFF;
          line-height: 24px;
        }
      }
      .right {
        width: 68%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        .r-left,.r-right {
          width: 48.5%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .top {
            position: relative;
            img {
              width: 100%;
              height: 114px;
            }
            div:nth-of-type(1){
              position: absolute;
              top: 24px;
              left: 24px;
              height: 33px;
              font-size: 24px;
              font-weight: 600;
              color: #FFFFFF;
              line-height: 33px;
            }
            div:nth-of-type(2){
              position: absolute;
              top: 61px;
              left: 24px;
              height: 24px;
              font-size: 20px;
              color: #FFFFFF;
              line-height: 24px;
            }
          }
        }
        .r-right {
          width: 48.5%;
        }
      }
    }
    .outcome-body {
      position: relative;
      padding: 0 46px;
      box-sizing: border-box;
      ul {
        display: flex;
        flex-wrap: wrap;
        li {
          position: relative;
          flex: 0 0 228px;
          height: 280px;
          margin-right: 12px;
          margin-bottom: 12px;
          &:nth-child(5n) {
            margin-right: 0;
          }
          img {
            width: 100%;
            height: 100%;
          }
          .mask {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            font-size: 16px;
            color: #fff;
            font-weight: 500;
            background-color: rgba(46, 92, 154, 0.7);
          }
        }
      }
    }
    .prev-icon {
      position: absolute;
      top: 50%;
      left: 0;
      z-index: 1;
      transform: translateY(-50%);
      width: 30px;
      height: 30px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .next-icon {
      position: absolute;
      top: 50%;
      right: 0;
      z-index: 1;
      transform: translateY(-50%);
      width: 30px;
      height: 30px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .humanities-culture {
    padding-bottom: 48px;
    .humanities-culture-header {
      display: flex;
      padding-bottom: 20px;
      font-size: 24px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 33px;
    }
    .mask {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 1;
      width: 100%;
      height: 60px;
      line-height: 60px;
      padding-left: 24px;
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      box-sizing: border-box;
      background-color: rgba(0, 0, 0, .6);
    }
    .humanities-culture-body {
      display: flex;
      margin-bottom: 14px;
      .left {
        position: relative;
        margin-right: 14px;
        width: 632px;
        height: 500px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        .desc {
          display: flex;
          align-items: center;
          margin-bottom: 14px;
          width: 634px;
          height: 246px;
          padding: 0 37px;
          font-size: 14px;
          line-height: 20px;
          color: #fff;
          text-indent: 2em;
          box-sizing: border-box;
          background-color: rgba(170, 47, 51, 1);
        }
        .bottom {
          display: flex;
          .item {
            position: relative;
            margin-right: 14px;
            width: 310px;
            height: 240px;
            &:last-child {
              margin-right: 0;
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .avatar-list {
      display: flex;
      flex-wrap: wrap;
      .avatar-item {
        position: relative;
        flex: 0 0 310px;
        margin-right: 12px;
        margin-bottom: 14px;
        height: 240px;
        &:nth-child(4n) {
          margin-right: 0;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .experimental {
    padding-bottom: 80px;
    .experimental-header {
      margin-bottom: 22px;
      font-size: 24px;
      font-weight: 500;
      line-height: 33px;
      color: rgba(0, 0, 0, 0.85);
    }
    .experimental-body {
      position: relative;
      width: 100%;
      height: 480px;
      img {
        width: 100%;
        height: 100%;
      }
      ul {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
        width: 640px;
        height: 100%;
        padding: 6px 24px 0 24px;
        background-color: rgba(46, 92, 154, 0.95);
        box-sizing: border-box;
        li {
          position: relative;
          width: 100%;
          height: 90px;
          padding-top: 20px;
          box-sizing: border-box;
          .title-box {
            display: flex;
            align-items: center;
            margin-bottom: 6px;
            .title {
              margin-right: 10px;
              font-size: 16px;
              line-height: 22px;
              color: #fff;
            }
            .status {
              width: 48px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              font-size: 14px;
              color: #fff;
              border-radius: 2px;
              &.show {
                background-color: rgba(170, 47, 51, 1);
              }
              &.end {
                background-color: rgba(0, 0, 0, 0.65);
              }
            }
          }
          .date-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            color: #fff;
            line-height: 20px;
          }
          .line {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            border-top: 1px solid rgba(19, 77, 126, 1);
            border-bottom: 1px solid rgba(72, 116, 177, 1);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/achievements/index.vue